import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ServiceOrderManagementService {
  api = environment.api;

  constructor( private http: HttpClient ) { }

  listServicesOrdersManagement(filters = "") {
    return this.http.get(this.api+`/aprovacao-ordem-servico${filters}`);
  }

  getServicesOrdersManagement(id) {
    return this.http.get(this.api+`/aprovacao-ordem-servico/${id}`);
  }

  approvedServicesOrdersManagement(raw) {
    return this.http.put(this.api+`/aprovacao-ordem-servico/aprovar`, raw);
  }

  disapprovedServicesOrdersManagement(raw) {
    return this.http.put(this.api+`/aprovacao-ordem-servico/reprovar`, raw);
  }
}
